import { Injectable } from '@angular/core';
import { ClinicItemJSON } from '../common/models/server-response/clinic-item-json.model';
import { BehaviorSubject, take } from 'rxjs';
import { AddressInfo } from '../common/models/internal/address-info.model';
import { ClinicOfficeListItem } from '../common/models/internal/clinic-office-list-item.model';
import { RequestsService } from './requests.service';
import { ClinicOfficeListService } from './clinic-office-list.service';
import { ENTOfficeItemJSON } from '../common/models/server-response/ent-office-item-json.model';
import { RequestedOfficeHistoryItemJSON } from '../common/models/server-response/requested-office-history-item-json.model';
import { RequestedClinicHistoryItemJSON } from '../common/models/server-response/requested-clinic-history-item-json.model';
import { ShopTypesServerSideEnum } from '../common/enums/shop-types-server-side-enum';
import { ShopStateEnum } from '../common/enums/shop-state-enum';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';

@Injectable({
  providedIn: 'root'
})
export class ClinicOfficeManageService
{

  currentClinicOffice: ClinicOfficeListItem | undefined
  editedClinicOffice: ClinicOfficeListItem | undefined
  officeLog: RequestedOfficeHistoryItemJSON | undefined
  clinicLog: RequestedClinicHistoryItemJSON | undefined

  address: AddressInfo | undefined

  coordinatesToUpdate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  constructor(private requestsService: RequestsService, private clinicOfficeListService: ClinicOfficeListService, private serverValueInterpreterService: ServerValueInterpreterService) { }

  createClinicOffice()
  {
    if (this.currentClinicOffice)
    {
      if (this.currentClinicOffice.type1 == ShopTypesEnum.clinic)
      {

        let l_clinic: ClinicItemJSON = {
          email: this.currentClinicOffice.email,
          state: this.currentClinicOffice.state,
          zipCode: this.currentClinicOffice.zipCode,
          phone: this.currentClinicOffice.phone,
          openingHours: this.currentClinicOffice.openingHours,
          googleMaps: {
            geolocation: {
              longitude: this.currentClinicOffice.geolocation.longitude,
              latitude: this.currentClinicOffice.geolocation.latitude
            }
          },
          shopType: this.currentClinicOffice.shopType,
          brandId: this.currentClinicOffice.brand ? this.currentClinicOffice.brand : '',
          city: this.currentClinicOffice.city,
          shopId: this.currentClinicOffice.clinicOfficeId,
          appleMaps: {
            geolocation: {
              longitude: this.currentClinicOffice.geolocation.longitude,
              latitude: this.currentClinicOffice.geolocation.latitude
            }
          },
          presentedForSelection: this.currentClinicOffice.shown,
          country: this.serverValueInterpreterService.getFullCountryNameById(this.currentClinicOffice.countryId),
          addressLine1: this.currentClinicOffice.addressLine1,
          addressLine2: this.currentClinicOffice.addressLine2,
          shopName: this.currentClinicOffice.name,
          crmType: this.currentClinicOffice.crmType?this.currentClinicOffice.crmType:null
        }

        this.requestsService.createClinic(l_clinic, this.currentClinicOffice?.countryId).pipe(take(1)).subscribe(l_response =>
        {
          console.log(l_response)
          this.clinicOfficeListService.needsToRefresh.next(true);
          this.clearAll()
        })
      } else if (this.currentClinicOffice.type1 == ShopTypesEnum.entOffice)
      {
        let l_office: ENTOfficeItemJSON = {
          email: [this.currentClinicOffice.email],
          state: this.currentClinicOffice.state,
          zipCode: this.currentClinicOffice.zipCode,
          phone: [this.currentClinicOffice.phone],
          webpage: this.currentClinicOffice.website ? this.currentClinicOffice.website : '',
          openingHours: this.currentClinicOffice.openingHours,
          googleMaps: {
            geolocation: {
              longitude: this.currentClinicOffice.geolocation.longitude,
              latitude: this.currentClinicOffice.geolocation.latitude
            }
          },
          city: this.currentClinicOffice.city,
          id: this.currentClinicOffice.clinicOfficeId,
          appleMaps: {
            geolocation: {
              longitude: this.currentClinicOffice.geolocation.longitude,
              latitude: this.currentClinicOffice.geolocation.latitude
            }
          },
          hidden: !this.currentClinicOffice.shown,
          country: this.serverValueInterpreterService.getFullCountryNameById(this.currentClinicOffice.countryId),
          addressLine1: this.currentClinicOffice.addressLine1,
          addressLine2: this.currentClinicOffice.addressLine2,
          entOfficeName: this.currentClinicOffice.name,
          countryId: this.currentClinicOffice.countryId,
          relatedShops: [],
          doctors:this.currentClinicOffice.doctors
        }

        this.requestsService.createOffice(l_office, this.currentClinicOffice?.countryId).pipe(take(1)).subscribe(l_response =>
        {
          console.log(l_response)
          this.clinicOfficeListService.needsToRefresh.next(true);
          this.clearAll()
        })
      }


    }
  }

  editClinicOffice()
  {
    if (this.editedClinicOffice)
    {
      if (this.editedClinicOffice.type1 == ShopTypesEnum.clinic)
      {

        let l_clinic: ClinicItemJSON = {
          email: this.editedClinicOffice.email,
          state: this.editedClinicOffice.state,
          zipCode: this.editedClinicOffice.zipCode,
          phone: this.editedClinicOffice.phone,
          openingHours: this.editedClinicOffice.openingHours,
          googleMaps: {
            geolocation: {
              longitude: this.editedClinicOffice.geolocation.longitude,
              latitude: this.editedClinicOffice.geolocation.latitude
            }
          },
          shopType: this.editedClinicOffice.shopType,
          brandId: this.editedClinicOffice.brand ? this.editedClinicOffice.brand : '',
          city: this.editedClinicOffice.city,
          shopId: this.editedClinicOffice.clinicOfficeId,
          appleMaps: {
            geolocation: {
              longitude: this.editedClinicOffice.geolocation.longitude,
              latitude: this.editedClinicOffice.geolocation.latitude
            }
          },
          presentedForSelection: this.editedClinicOffice.shown,
          country: this.serverValueInterpreterService.getFullCountryNameById(this.editedClinicOffice.countryId),
          addressLine1: this.editedClinicOffice.addressLine1,
          addressLine2: this.editedClinicOffice.addressLine2,
          shopName: this.editedClinicOffice.name,
          crmType: this.editedClinicOffice.crmType?this.editedClinicOffice.crmType:null
        }

        this.requestsService.editClinic(l_clinic, this.editedClinicOffice?.countryId).pipe(take(1)).subscribe(l_response =>
        {
          console.log(l_response)
          this.clinicOfficeListService.needsToRefresh.next(true);
          this.clearAll()
        })
      } else if (this.editedClinicOffice.type1 == ShopTypesEnum.entOffice)
      {
        let l_office: ENTOfficeItemJSON = {
          email: [this.editedClinicOffice.email],
          state: this.editedClinicOffice.state,
          zipCode: this.editedClinicOffice.zipCode,
          phone: [this.editedClinicOffice.phone],
          openingHours: this.editedClinicOffice.openingHours,
          webpage: this.editedClinicOffice.website ? this.editedClinicOffice.website : '',
          googleMaps: {
            geolocation: {
              longitude: this.editedClinicOffice.geolocation.longitude,
              latitude: this.editedClinicOffice.geolocation.latitude
            }
          },
          city: this.editedClinicOffice.city,
          id: this.editedClinicOffice.clinicOfficeId,
          appleMaps: {
            geolocation: {
              longitude: this.editedClinicOffice.geolocation.longitude,
              latitude: this.editedClinicOffice.geolocation.latitude
            }
          },
          hidden: !this.editedClinicOffice.shown,
          country: this.serverValueInterpreterService.getFullCountryNameById(this.editedClinicOffice.countryId),
          addressLine1: this.editedClinicOffice.addressLine1,
          addressLine2: this.editedClinicOffice.addressLine2,
          entOfficeName: this.editedClinicOffice.name,
          countryId: this.editedClinicOffice.countryId,
          relatedShops: [],
          doctors:this.editedClinicOffice.doctors
        }

        this.requestsService.editOffice(l_office, this.editedClinicOffice?.countryId).pipe(take(1)).subscribe(l_response =>
        {
          console.log(l_response)
          this.clinicOfficeListService.needsToRefresh.next(true);
          this.clearAll()
        })
      }


    }
  }

  deleteClinicOffice()
  {
    if (this.currentClinicOffice)
    {
      if (this.currentClinicOffice.type1 == ShopTypesEnum.clinic)
      {
        if (this.clinicOfficeListService.filterByShopState.value == ShopStateEnum.published)
        {
          this.requestsService.createShopRequestFromExistingShop(this.currentClinicOffice.clinicOfficeId, this.currentClinicOffice.countryId).pipe(take(1)).subscribe(l_resp =>
          {
            if (l_resp && l_resp.itemId)
            {
              this.requestsService.deleteClinic(l_resp.itemId).pipe(take(1)).subscribe(l_resp =>
              {
                console.log(l_resp)
                this.clinicOfficeListService.needsToRefresh.next(true);
                this.clinicOfficeListService.getTimestampsZipCodeRelation();
              })
            }
          })

        } else if (this.clinicOfficeListService.filterByShopState.value == ShopStateEnum.requested)
        {
          this.requestsService.deleteClinic(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
          {
            console.log(l_resp)
            this.clinicOfficeListService.needsToRefresh.next(true);
          })
        }

      } else if (this.currentClinicOffice.type1 == ShopTypesEnum.entOffice)
      {
        if (this.clinicOfficeListService.filterByShopState.value == ShopStateEnum.published)
        {
          this.requestsService.createEntRequestFromExistingEnt(this.currentClinicOffice.clinicOfficeId, this.currentClinicOffice.countryId).pipe(take(1)).subscribe(l_resp =>
          {
            if (l_resp && l_resp.itemId)
            {
              this.requestsService.deleteOffice(l_resp.itemId).pipe(take(1)).subscribe(l_resp =>
              {
                console.log(l_resp)
                this.clinicOfficeListService.needsToRefresh.next(true);
              })
            }
          })
        } else if (this.clinicOfficeListService.filterByShopState.value == ShopStateEnum.requested)
        {
          this.requestsService.deleteOffice(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
          {
            console.log(l_resp)
            this.clinicOfficeListService.needsToRefresh.next(true);
          })
        }
      }
    }
  }

  rejectClinicOffice()
  {
    if (this.currentClinicOffice)
    {
      if (this.currentClinicOffice.type1 == ShopTypesEnum.clinic)
      {
        this.requestsService.rejectClinic(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
        {
          console.log(l_resp)
          this.clinicOfficeListService.needsToRefresh.next(true);

        })
      } else if (this.currentClinicOffice.type1 == ShopTypesEnum.entOffice)
      {
        this.requestsService.rejectOffice(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
        {
          console.log(l_resp)
          this.clinicOfficeListService.needsToRefresh.next(true);
        })
      }
    }
  }

  approveClinicOffice()
  {
    if (this.currentClinicOffice)
    {
      if (this.currentClinicOffice.type1 == ShopTypesEnum.clinic)
      {
        this.requestsService.approveClinic(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
        {
          console.log(l_resp)
          this.clinicOfficeListService.needsToRefresh.next(true);
          this.clinicOfficeListService.getTimestampsZipCodeRelation();
        })
      } else if (this.currentClinicOffice.type1 == ShopTypesEnum.entOffice)
      {
        this.requestsService.approveOffice(this.currentClinicOffice.clinicOfficeId).pipe(take(1)).subscribe(l_resp =>
        {
          console.log(l_resp)
          this.clinicOfficeListService.needsToRefresh.next(true);
        })
      }
    }
  }

  loadLog(): BehaviorSubject<boolean>
  {
    let l_loaded = new BehaviorSubject<boolean>(false)

    if (this.currentClinicOffice)
    {
      if (this.currentClinicOffice.type1 == ShopTypesEnum.clinic)
      {
        this.requestsService.getItemLog(this.currentClinicOffice.clinicOfficeId, ShopTypesServerSideEnum.clinic).pipe(take(1)).subscribe(l_log =>
        {
          this.clinicLog = l_log
          l_loaded.next(true)
        })
      } else if (this.currentClinicOffice.type1 == ShopTypesEnum.entOffice)
      {

        this.requestsService.getItemLog(this.currentClinicOffice.clinicOfficeId, ShopTypesServerSideEnum.entOffice).pipe(take(1)).subscribe(l_log =>
        {
          this.officeLog = l_log
          l_loaded.next(true)
        })
      }


    }

    return l_loaded
  }

  clearAll()
  {
    this.currentClinicOffice = undefined
    this.editedClinicOffice = undefined
    this.officeLog = undefined
    this.clinicLog = undefined
    this.address = undefined
  }
}
